// extracted by mini-css-extract-plugin
export default {"layoutRoot":"layout_layoutRoot__DqWys"};